import React from 'react';
import { useSelector } from 'react-redux';
import { getSuggestions } from '@src/containers/Filters/selectors/getSuggestions';
import EventCard from '@src/components/EventCard';

import Suggestions from '..';

const SuggestionsCDefault = (props) => {
	const items = useSelector(getSuggestions);

	return (
		<Suggestions
			events={items}
			src="/img/null.svg"
			forceVisibility
			{...props}
			NavCardRP={EventCard}
		/>
	);
};

export default SuggestionsCDefault;
